/**
 * ConnectWalletButton - Botón para conectar wallet usando Thirdweb (como DeFily)
 * Inicio de sesión con Thirdweb comentado - no se muestra el botón
 */

// import ConnectWalletButtonComponent from '../../../features/third-web/components/connect-wallet-button.component';
// import './ConnectWalletButton.css';

const ConnectWalletButton = () => {
  // Thirdweb comentado - no mostrar botón Connect Wallet de Thirdweb
  return null;
  // return (
  //   <div className="wallet-connect-container-hyperliquid">
  //     <ConnectWalletButtonComponent />
  //   </div>
  // );
};

export default ConnectWalletButton;
